<template>
  <div class="toast" v-show="show">{{ message }}</div>
</template>

<script>
const COMPONENT_NAME = 'toast'
export default {
  name: COMPONENT_NAME,
  data () {
    return {
      show: false,
      message: ''
    }
  }
}
</script>

<style lang="scss">
.toast {
  position: fixed;
  z-index: 20002;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  padding: 13px 16px;
  font-size: 16px;
  border-radius: 6px;
  text-align: center;
  color: #ccc;
  background-color: rgba(99, 101, 112, 0.9);;
}
</style>
